import React from "react";
import { SvgComponent } from "@commons/Componentes/SvgComponent/SvgComponent";
import { RevisionSeccion } from "./RevisionSeccion";

const TONO = {
  A: "validada",
  C: "modelo",
  R: "riesgo",
  D: "pendiente",
  P: "validada",
  M: "modelo"
};

const ICONO_EVENTO = {
  D: "pencil",
  P: "check",
  M: "lightbulb"
};

export const RevisionHistorial = ({ historial }) => (
  <RevisionSeccion titulo="Historial de revisiones" icono="history">
    {historial?.length ? (
      <ol className="citrus-ia-historial">
        {historial.map((revision) => (
          <li key={revision.Id} className={revision.EsVeredicto ? undefined : "citrus-ia-historial__evento"}>
            <div className="citrus-ia-lista__titulo">
              <span className={`citrus-gpt-tag citrus-gpt-tag--${TONO[revision.Veredicto] || "neutra"}`}>
                {ICONO_EVENTO[revision.Veredicto] && (
                  <SvgComponent iconName={ICONO_EVENTO[revision.Veredicto]} width="13px" height="13px" fill="currentColor" />
                )}
                {revision.VeredictoDesc}
              </span>
              <span className="citrus-ia-historial__quien">
                por <strong>{revision.ExpertoUsuario}</strong> el {revision.Fecha}
              </span>
            </div>
            {revision.TipoErrorDesc && (
              <p className="citrus-ia-lista__cita">Qué estaba mal: {revision.TipoErrorDesc}</p>
            )}
            {revision.Motivo && <p className="citrus-ia-lista__cita">{revision.Motivo}</p>}
            {revision.ProponeDocumentacion && (
              <p className="citrus-ia-lista__cita">Marcó un vacío documental.</p>
            )}
            {revision.Detalle && (
              <details className="citrus-ia-historial__detalle">
                <summary>Ver el conocimiento agregado</summary>
                <pre>{revision.Detalle}</pre>
              </details>
            )}
          </li>
        ))}
      </ol>
    ) : (
      <p className="citrus-ia-lista__cita">Todavía nadie la ha revisado.</p>
    )}
  </RevisionSeccion>
);
